import { cva } from "class-variance-authority";

export const tagVariants = cva("appearance-none rounded-lg font-normal border px-2 py-0.5 whitespace-nowrap text-center w-fit", {
  variants: {
    font: {
      normal: "font-normal",
      bold: "font-bold",
    },
    variant: {
      primary: "text-[#213F93] bg-[#E2E7F4] border-[#E2E7F4]",
      success: "text-[#009951] bg-[#CFF7D3] border-[#009951]",
      warning: "text-[#BF6A02] bg-[#FFF1C2]  border-[#BF6A02]",
      danger: "text-[#FEE9E7] bg-[#EC221F] border-[#EC221F]",
      neutral: "text-[#1E1E1E] bg-[#D9D9D9] border-[#D9D9D9]",
    },
    border: {
      include: "",
      none: "border-none",
    },
    size: {
      small: "text-xs",
      medium: "text-sm",
      large: "text-lg",
    },
    width: {
      auto: "w-fit",
      sm: "w-20",
      md: "w-32",
      lg: "w-48",
      full: "w-full",
    },
  },
  defaultVariants: {
    font: "normal",
    variant: "primary",
    border: "include",
    size: "medium",
    width: "auto",
  },
});
